import { useEffect, useRef } from 'react'
import './CategoryNav.css'

function CategoryNav({
  categories,
  activeId,
  onSelect,
  onLogoClick,
  onReachEnd,
  hasMore = false,
  variant = 'mobile',
  logoUrl = null,
  stuck = false,
}) {
  const listRef = useRef(null)
  const activeRef = useRef(null)
  const endRef = useRef(null)
  const logoSrc = String(logoUrl ?? '').trim()

  useEffect(() => {
    if (variant !== 'mobile') return
    const link = activeRef.current
    const list = listRef.current
    if (!link || !list) return
    const listRect = list.getBoundingClientRect()
    const linkRect = link.getBoundingClientRect()
    const delta =
      linkRect.left - listRect.left - (listRect.width / 2 - linkRect.width / 2)
    list.scrollBy({ left: delta, behavior: 'smooth' })
  }, [activeId, variant])

  useEffect(() => {
    if (!hasMore || !onReachEnd) return
    const el = endRef.current
    const root = listRef.current
    if (!el || !root) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) onReachEnd()
      },
      { root, rootMargin: '40px' }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [hasMore, onReachEnd, categories.length, variant])

  if (!categories?.length) return null

  return (
    <nav
      className={[
        'category-nav',
        `category-nav--${variant}`,
        stuck ? 'category-nav--stuck' : '',
        logoSrc ? 'category-nav--has-logo' : '',
      ].filter(Boolean).join(' ')}
      aria-label="Категории"
    >
      {logoSrc ? (
        <button
          type="button"
          className="category-nav-logo"
          aria-hidden={!stuck}
          tabIndex={stuck ? 0 : -1}
          aria-label="Наверх"
          onClick={() => onLogoClick?.()}
        >
          <span className="category-nav-logo-inner">
            <img className="category-nav-logo-image" src={logoSrc} alt="" />
          </span>
        </button>
      ) : null}

      <div className="category-nav-list" ref={listRef}>
        {categories.map((category) => {
          const id = category.id ?? category._id
          const isActive = activeId != null && String(activeId) === String(id)

          return (
            <button
              key={String(id)}
              type="button"
              ref={isActive ? activeRef : null}
              className={`category-nav-tag${isActive ? ' category-nav-tag--active' : ''}`}
              onClick={() => onSelect?.(category)}
            >
              {category.name}
            </button>
          )
        })}
        {hasMore ? <div ref={endRef} className="category-nav-end" aria-hidden="true" /> : null}
      </div>
    </nav>
  )
}

export default CategoryNav
